// es_ES language file
// Generated from Feishu Bitable
// Total entries: 565

export default{
    "game_diamond": {
        "title": "Info de Diamantes de Juego",
        "title0_title": "Cómo conseguir Diamantes de Juego",
        "title0": {
            "txt1": "1. Gánalos en tareas o eventos específicos.",
            "txt2": "2. No se compran con recarga."
        },
        "title1_title": "Uso de los Diamantes de Juego",
        "title1": {
            "txt1": "1. Solo para juegos.",
            "txt2": "2. En el juego, los Diamantes de Juego equivalen a los diamantes normales y se usan directamente. Los que ganes con Diamantes de Juego serán normales.",
            "txt3": "3. Se usan primero los diamantes de juego.",
            "txt4": "4. Se combinan con diamantes. Ej.: 200 + 800 = 1000 gastados juntos."
        },
        "title2_title": "Vigencia de los Diamantes de Juego",
        "title2": {
            "txt1": "1. Tienen validez limitada y serán eliminados al expirar."
        }
    },
    "guanxi_gift_rule_title": "Descripción del regalo",
    "guanxi_gift_rule_1": "Después de enviar un regalo de relación, el destinatario puede elegir si desea formar una relación contigo. Solo puede haber una relación entre dos personas a la vez.",
    "guanxi_gift_rule_2": "Cada persona puede tener hasta 3 relaciones, y los tipos de relación pueden ser los mismos.",
    "guanxi_gift_rule_3": "Puedes terminar una relación 24 horas después de haberla formado. Después de terminar una relación, puedes formar una nueva después de otras 24 horas.",
    "not_exist": "No encontrado",
    "mbti_intro_title": "Descripciones MBTI",
    "mbti_intro_pers": "Rasgos de Personalidad",
    "mbti_intro_love": "Rasgos Románticos",
    "mbti_intro_istj_pers": "Personalidad del Inspector",
    "mbti_intro_istj_feature": "Serios, tranquilos, detallistas y precisos, prefieren una vida ordenada y estructurada. Confiables y responsables, siguen reglas y tradiciones.",
    "mbti_intro_istj_love": "En el amor, los ISTJ son compañeros leales y estables. Toman las relaciones en serio, centrándose en el compromiso y la responsabilidad, mostrando su cariño con acciones más que con palabras, y necesitan tiempo para formar conexiones profundas.",
    "mbti_intro_isfj_pers": "Personalidad del Cuidador",
    "mbti_intro_isfj_feature": "Amables, bondadosos y empáticos, son atentos a las necesidades de los demás y pacientes. Detallistas, son excelentes oyentes y apoyo constante.",
    "mbti_intro_isfj_love": "En relaciones, los ISFJ son profundamente atentos, cuidan los detalles de la vida de su pareja y crean un ambiente cálido y acogedor. Generalmente tradicionales, pueden tomarse su tiempo para comprometerse, pero son muy leales una vez que lo hacen.",
    "mbti_intro_infj_pers": "Personalidad del Arquitecto",
    "mbti_intro_infj_feature": "Perspicaces y creativos, con un profundo entendimiento de la humanidad y el futuro. Tienen una vida interior rica y son reflexivos y analíticos.",
    "mbti_intro_infj_love": "Los INFJ buscan una conexión mental y emocional con su pareja, valoran las conversaciones profundas. Tienen ideales altos en el amor y, cuando aman, son enfocados y devotos.",
    "mbti_intro_intj_pers": "Personalidad del Comandante",
    "mbti_intro_intj_feature": "Lógicos, tranquilos y seguros, con fuertes habilidades analíticas y de toma de decisiones, valoran el conocimiento y la sabiduría y persiguen sus metas tenazmente.",
    "mbti_intro_intj_love": "En relaciones, los INTJ abordan el amor racionalmente, valorando creencias y metas compartidas. Aunque reservados con las emociones, demuestran su cariño a través de acciones cuidadosas.",
    "mbti_intro_istp_pers": "Personalidad del Artesano",
    "mbti_intro_istp_feature": "Práctico, observador y analítico, disfruta de tareas manuales y de resolver problemas prácticos, especialmente en áreas mecánicas o técnicas.",
    "mbti_intro_istp_love": "Los ISTP son espontáneos y libres en las relaciones, disfrutando el momento presente con sus parejas y compartiendo los placeres de la vida sin muchas restricciones.",
    "mbti_intro_isfp_pers": "Personalidad del Artista",
    "mbti_intro_isfp_feature": "Sensibles, amables y artísticos, priorizan experiencias emocionales y sensoriales, a menudo expresándose a través de formas creativas.",
    "mbti_intro_isfp_love": "En relaciones, los ISFP son románticos y considerados, hábiles en crear un ambiente encantador, y a menudo sorprenden a sus parejas. Pueden ser emocionales y necesitan un compañero que los comprenda y apoye.",
    "mbti_intro_infp_pers": "Personalidad del Mediador",
    "mbti_intro_infp_feature": "Idealistas, amables y empáticos, tienen una rica vida interior y una profunda comprensión de la naturaleza humana, valorando la armonía y la belleza.",
    "mbti_intro_infp_love": "Los INFP invierten profundamente en las relaciones, buscando fuertes conexiones emocionales. Valoran los intercambios emocionales y comparten una visión esperanzadora del amor.",
    "mbti_intro_intp_pers": "Personalidad del Lógico",
    "mbti_intro_intp_feature": "Analíticos y curiosos, tienen un fuerte deseo de conocimiento, explorando áreas desconocidas en busca de la verdad.",
    "mbti_intro_intp_love": "En relaciones, los INTP son lógicos, centrándose en la compatibilidad intelectual y emocional. Aunque pueden ser reservados al expresar sus sentimientos, usan discusiones para fomentar el entendimiento mutuo.",
    "mbti_intro_estp_pers": "Personalidad del Emprendedor",
    "mbti_intro_estp_feature": "Enérgicos, extrovertidos y aventureros, disfrutan de las interacciones sociales y de tomar riesgos, aprovechando activamente las oportunidades.",
    "mbti_intro_estp_love": "En relaciones, los ESTP son vibrantes y apasionados, les encanta explorar nuevas experiencias con sus parejas. Son directos y expresan sus pensamientos y sentimientos abiertamente.",
    "mbti_intro_esfp_pers": "Personalidad del Intérprete",
    "mbti_intro_esfp_feature": "Extrovertidos, optimistas y expresivos, disfrutan socializando y entreteniéndose, aportando energía y entusiasmo.",
    "mbti_intro_esfp_love": "En el amor, los ESFP son compañeros animados que disfrutan de actividades sociales compartidas, enfatizando los sentimientos actuales y experiencias, trayendo alegría y emoción a sus parejas.",
    "mbti_intro_enfp_pers": "Personalidad del Defensor",
    "mbti_intro_enfp_feature": "Creativos, enérgicos y cálidos, les encanta interactuar con los demás y entienden profundamente las emociones ajenas.",
    "mbti_intro_enfp_love": "Los ENFP son como el sol en las relaciones, trayendo calidez y alegría a sus parejas. Llenos de romance, expresan activamente su amor y esperan crear hermosos recuerdos juntos.",
    "mbti_intro_entp_pers": "Personalidad del Debatiente",
    "mbti_intro_entp_feature": "Inteligentes, ingeniosos y curiosos, disfrutan debatiendo y explorando nuevas ideas y temas.",
    "mbti_intro_entp_love": "Los ENTP se involucran en discusiones profundas y debates con sus parejas, disfrutando del desafío y el crecimiento intelectual en el amor. A menudo juguetones, aportan humor a la relación.",
    "mbti_intro_estj_pers": "Personalidad Ejecutiva",
    "mbti_intro_estj_feature": "Prácticos, decididos y seguros, con fuertes habilidades organizativas y de liderazgo, priorizan la eficiencia y los resultados.",
    "mbti_intro_estj_love": "En el amor, los ESTJ son firmes y decididos, persiguiendo activamente sus intereses y planificando para el futuro. Muestran afecto a través de apoyo práctico y acciones.",
    "mbti_intro_esfj_pers": "Personalidad del Cónsul",
    "mbti_intro_esfj_feature": "Amistosos y cálidos, son sociables y se preocupan por los demás, valorando la tradición y los lazos familiares.",
    "mbti_intro_esfj_love": "Los ESFJ son compañeros atentos y cariñosos, creando un ambiente romántico y cálido. A menudo tradicionales, valoran las costumbres familiares de citas y la aprobación familiar.",
    "mbti_intro_enfj_pers": "Personalidad del Protagonista",
    "mbti_intro_enfj_feature": "Carismáticos y seguros, se conectan fácilmente y se comunican bien, entendiendo y guiando a los demás efectivamente.",
    "mbti_intro_enfj_love": "Los ENFJ son compañeros entusiastas y románticos, expresando abiertamente su amor y creando un ambiente cálido. Valoran el intercambio emocional y buscan formar un vínculo profundo con sus parejas.",
    "mbti_intro_entj_pers": "Personalidad Ejecutiva",
    "mbti_intro_entj_feature": "Lógicos, seguros y ambiciosos, con fuertes habilidades de liderazgo y toma de decisiones, valoran la excelencia y el éxito, manteniendo altos estándares para ellos y para los demás.",
    "mbti_intro_entj_love": "En el amor, los ENTJ están orientados a objetivos, eligiendo compañeros afines que apoyen el crecimiento mutuo. Priorizan la competencia y las ambiciones compartidas, profundizando las relaciones mediante metas comunes.",
    "expressProposalWall": "Muro de Declaraciones",
    "expressHowTo": "Cómo aparecer en el Muro de Declaraciones",
    "expressSend": "Entrega el regalo de declaración a tu amor. Tus palabras de amor se mostrarán en el muro de declaraciones.",
    "expressSend1": "1. Haz clic en \"Declarar ahora\" para ingresar a la página de la actividad y elige a la persona a la que quieres declarar tu amor.",
    "expressSend2": "2. Elige un regalo e ingresa lo que quieras decirle a él/ella en la tarjeta.",
    "expressSend3": "3. Haz clic en \"Enviar regalo\" y tu tarjeta de declaración se mostrará en el muro de declaraciones.",
    "expressDifferent": "Diferentes Tipos de el Regalo de Declaración",
    "expressWeHave": "Tenemos 4 tipos de Regalos de Declaración, como sigue.",
    "expressWeHave1": "1. Tarjeta de Regalo de Declaración Básica: Fondo de color simple.",
    "expressWeHave2": "2. Tarjeta de Regalo de Declaración Decorativa: Fondo colorido decorativo.",
    "expressWeHave3": "3. Tarjeta de Regalo de Declaración de Lujo: Fondo decorativo con efecto de lujo.",
    "expressWeHave4": "4. Tarjeta de Regalo de Declaración de Amor Verdadero: Fondo decorativo con efecto lujoso y acompañado de un anuncio en todo el servidor.",
    "expressProposal": "Rango de Visualización de la Tarjeta de Declaración",
    "expressProposal1": "1. Muro de Declaraciónes en la sala. (Haz clic en la barra encima del regalo de declaración)",
    "expressProposal2": "2. Muro de Declaraciónes junto a la página de Momentos.",
    "diamondDrop1": "1. Cuando un usuario envía regalos que suman más de 50,000 diamantes en una sala (los regalos de suerte se calculan al 10% del precio real del diamante), aparece un cofre de diamantes que cualquiera en la sala puede abrir para obtener diamantes.",
    "diamondDrop2": "2. Cada cofre tiene un tiempo de espera de 1 minuto antes de poder abrirse.",
    "diamondDrop3": "3. Los diamantes en cada cofre son limitados; una vez que termina la cuenta regresiva, ya no puedes reclamar diamantes de ese cofre.",
    "diamondDrop4": "4. Después de que el cofre se cierre, puedes hacer clic para ver cuántos diamantes obtuviste de él.",
    "baoxaingxianding": "宝箱限定",
    "cancelAccount": {
        "accountRecoveryContent": "Durante el período de recuperación, puedes iniciar sesión nuevamente usando tu método anterior y elegir recuperar tu cuenta. Una vez recuperada, recuperarás todos tus mensajes, niveles y diamantes de la cuenta.",
        "accountRecoveryTitle": "Recuperación de Cuenta:",
        "confirmCancellation": "¿Estás seguro de que quieres eliminar?",
        "convalescenceContent": "Después de enviar una solicitud de eliminación, tu cuenta será desactivada temporalmente por 30 días. Durante este tiempo, toda la información de tu cuenta, niveles y diamantes serán retenidos, permitiendo una recuperación sin problemas si cambias de opinión.",
        "convalescenceTitle": "Período de Recuperación:",
        "finalContent": "Si no eliges recuperar tu cuenta al final del período de recuperación (31 días desde la solicitud de eliminación), tu cuenta y todos los datos asociados serán eliminados permanentemente. Ten en cuenta que, una vez eliminados, tu cuenta y datos no podrán ser recuperados.",
        "finalTitle": "Eliminación Final:",
        "reserveContent": "Durante el período de recuperación, protegeremos los datos de tu cuenta para garantizar que no se pierdan o dañen.",
        "reserveTitle": "Retención de Datos:",
        "statementContent": "Solicitud de Eliminación: Después de enviar una solicitud de eliminación de cuenta, tu cuenta entrará en un \"período de recuperación\" de 30 días. Durante este tiempo, puedes optar por recuperar tu cuenta en cualquier momento. Si eres parte de una agencia, la eliminación de la cuenta no será posible.",
        "statementTitle": "Aviso de Eliminación de Cuenta:",
        "userContent": "Gracias por usar nuestros servicios. Entendemos que a veces puedes necesitar eliminar tu cuenta. Para asegurarnos de que tu decisión esté bien pensada y para proporcionar una oportunidad de reconsideración, describimos aquí el proceso de eliminación de cuenta y los términos relacionados.",
        "userTitle": "Estimado Usuario:"
    },
    "Countdown": "Cuenta Atrás",
    "Endactivity": "Evento Terminado",
    "eventDetails": "Detalles del Evento",
    "eventGifts": "Regalos del Evento",
    "eventList": "Tabla de Clasificación del Evento",
    "eventReward": "Recompensas del Evento",
    "eventRewards": {
        "player": "Jugadores Activos Diarios",
        "proportion": "Tasa de Retorno de Premios",
        "title": "Premios del Evento",
        "txt1": "1. Los datos del día anterior se calculan diariamente a las 00:00 (UTC+8).",
        "txt2": "2. Los premios se otorgan en función del número de participantes y los diamantes realmente gastados en la sala (apuestas del usuario menos otorgadas del usuario).",
        "txt3": "3. Los datos de la semana anterior se calculan todos los lunes a las 00:00 (UTC+8), y las recompensas se distribuyen dentro de los 3 días.",
        "txt4": "4. Tasa de Retorno de Premios:",
        "txt5": "5. Definición de Jugador Activo: Un jugador que apuesta más de 1.000 diamantes en un día."
    },
    "EventRules": "Reglas del Evento",
    "Eventtime": "Tiempo del Evento",
    "guild": {
        "guild_certification01": "Verificación de Agencia",
        "guild_certification02": "Bienvenida, Agencia",
        "guild_certification03": "Requisitos del reclutamiento",
        "guild_certification04": [
            "10 hosts firman contrato y se unen a la plataforma en una semana",
            "Capaz de proporcionar la identificación del agente y otros documentos con nombre real",
            "Proporcionar un perfil de la agencia, introducción del equipo, información de las hosts, reglas de ganancias de las hosts, etc."
        ],
        "guild_certification05": "Si cumples con los requisitos anteriores, envía tu información al correo electrónico oficial: \\n{s}\\nUna vez aprobado, un miembro del personal se pondrá en contacto contigo.",
        "guild_certification06": "Copiado al portapapeles",
        "guild_certification07": "Contacto para cooperación",
        "guild_certification08": "Copiar",
        "guild_certification09": "Información de Membresía",
        "guild_certification10": [
            {
                "title": "1. Reglas de Membresía",
                "value": [
                    "Los solicitantes deben acordar con el líder de la agencia para iniciar una solicitud de membresía en la plataforma. Una vez aprobados por el líder, se convierten en hosts firmados, contribuyendo a la agencia."
                ]
            },
            {
                "title": "2. Reglas de Renuncia",
                "value": [
                    "Para salir de la agencia después de unirte, hosts necesitan acordar con agente. Haz clic en \"Salir Agencia\" en la página de perfil de la agencia. El agente debe hacer clic en \"Aceptar Salida\" y luego el miembro saldrá de la agencia.",
                    "Después de que el retiro sea exitoso, puedes solicitar unirte a otra agencia."
                ]
            }
        ],
        "guild_certification11": "Información de la Agencia",
        "guild_certification12": [
            {
                "title": "Ganancias de la Agencia",
                "value": [
                    "Usuarios y hosts en las salas familiares reciben regalos, generando contribuciones para la agencia.",
                    "Ocurren ataques de Boss en las salas familiares.",
                    "Los hosts firmados con la agencia crean salas CP, y recibir regalos genera contribuciones para la agencia. (Los hosts no firmados no pueden crear salas CP y generar contribuciones para la familia después de unirse a la familia.)"
                ]
            }
        ],
        "InvitationCodeTitle": "Código de Invitación",
        "invite_rules_intriduction": "Reglas de Invitación",
        "invite_rules_intriduction_content": [
            "Los hosts pueden solicitar unirse a tu agencia y convertirse en hosts ingresando el código de invitación durante el registro.",
            "Los hosts que no ingresaron un código de invitación durante el registro pueden solicitar unirse a tu familia a través de la página de la familia, y luego solicitar convertirse en hosts."
        ]
    },
    "legend": {
        "title": "Febrero Legendario"
    },
    "officialMember": "Equipo Oficial",
    "prettyNumber": {
        "text": "Ⅰ. Recolección de ID Especial",
        "text1": "Después de alcanzar el Nivel 3 de Noble o superior, puedes reclamar un ID Especial correspondiente a tu nivel.",
        "text2": "Los Nobles de mayor nivel pueden reclamar un ID Especial de nivel inferior. Por ejemplo, un Noble 6 puede reclamar un ID Especial de Nivel 3.",
        "text3": "Cuando tu estado de Noble expira, el ID Especial también se vuelve inaccesible. Necesitas reactivar tu Noble para continuar usando el ID Especial.",
        "text5": "Una vez que reclames un ID Especial, no puedes cambiarlo por otro número del mismo nivel o inferior.",
        "text6": "Si alcanzas un nivel Noble superior mientras usas un ID Especial, puedes cambiar inmediatamente a un ID Especial de mayor nivel, y el ID original volverá a la tienda.",
        "text7": "Por ejemplo, un usuario Noble 4 que inicialmente reclama un ID Especial Noble 4 y luego se actualiza a Noble 6 no puede cambiar a un ID Especial Noble 4 o inferior, pero puede reclamar inmediatamente un ID Especial Noble 6.",
        "title": "Explicación",
        "title1": "Ⅱ. Expiración del ID Especial",
        "title2": "Ⅲ. Reemplazo del ID Especial"
    },
    "reception": {
        "reception01": "Explicación del Ranking de Regalos",
        "reception02": [
            {
                "title": "¿Qué es el Ranking de Regalos de la Sala?",
                "value": [
                    "El Ranking de Regalos de la Sala es una clasificación en tiempo real de los regalos recibidos en la sala",
                    "Recuento de regalos de la sala = Recuento de regalos de diamantes"
                ]
            },
            {
                "title": "¿Cómo se clasifica el Ranking de Regalos de la Sala?",
                "value": [
                    "La clasificación se determina en función de los ingresos totales de todas las salas, calculados de manera integral",
                    "Ranking por Hora: Se reinicia cada hora en UMT+8",
                    "Ranking Diario: Se reinicia a las 00:00 UMT+8 todos los días"
                ]
            },
            {
                "title": "El Top 1 en el Ranking por Hora se transmite a todo el servidor",
                "value": [
                    "La sala Top 1 en el ranking de regalos por hora se anuncia en todas las salas del servidor"
                ]
            }
        ]
    },
    "roomParty": {
        "back": "Regresar",
        "event_rule": "<p>1. Tabla de Duración: Rastrea el tiempo total que los usuarios pasan en todas las posiciones de micrófono de la sala durante el evento. Los 3 principales contribuyentes en las 3 principales salas recibirán recompensas.</p><p>2. Tabla de Generosidad: Rastrea el número total de diamantes recibidos en la sala durante el evento. Los 3 mayores gastadores de diamantes en las 3 principales salas recibirán recompensas.</p><p>3. Este evento es un evento de ciclo semanal, con la tabla de clasificación restableciéndose y recalculándose cada semana.</p>",
        "last_week": "La Semana Pasada",
        "last_week_rank": "Detalles del Ranking de la Semana Pasada",
        "reward": "Recompensas",
        "rich_rank": "Ranking de Regalos de la Sala",
        "rule": "Reglas",
        "rule_reward": "Reglas y Recompensas",
        "time_rank": "Tabla de Duración",
        "title": "Sala Familiar",
        "top1": "Top 1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_1_name": "Marco de Avatar por 14 días",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/mount/thunder_armor.png",
        "top1_pictures_2_name": "Efectos de Entrada por 14 días",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_3_name": "Marco de Avatar por 14 días",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_4_name": "Marco de Avatar por 7 días",
        "top2": "Top 2",
        "top3": "Top 3"
    },
    "TopUpRewards": "Recompensas de Recarga",
    "treasure_chest": {
        "title": "Instrucciones de Regalos del Cofre del Tesoro",
        "value1": "Hay tres tipos de cofres del tesoro: Madera, Plata y Oro.",
        "value2": "Al abrir un cofre del tesoro, recibirás un regalo al azar del cofre y lo enviarás.",
        "value3": "El remitente gana puntos de experiencia según los diamantes gastados, mientras que el destinatario recibe Monedas y puntos de encanto según el valor del regalo del cofre.",
        "value4": "Cofre de Madera, con un precio de 1500 diamantes, contiene los siguientes regalos:",
        "value5": "Cofre de Plata, con un precio de 7500 diamantes, contiene los siguientes regalos:",
        "value6": "Cofre de Oro, con un precio de 25000 diamantes, contiene los siguientes regalos:",
        "value7": "Los regalos del cofre del tesoro son solo para entretenimiento e interacción social. Cualquier acción que afecte la justicia o explote errores del producto estará prohibida. Si se detecta, la plataforma bloqueará la cuenta y se reserva el derecho de emprender acciones legales."
    },
    "treasure_name": {
        "name1": "Cofre de Madera",
        "name2": "Cofre de Plata",
        "name3": "Cofre de Oro",
        "name4": "Probabilidad"
    },
    "Value": "Valor:",
    "Webname": {
        "addUid": "Agregar UID",
        "balance": "Saldo:",
        "Confirm": "Confirmar",
        "err_uid": "UID no válido, por favor ingresa nuevamente",
        "lang": "Seleccionar Idioma",
        "Query": "Buscar",
        "recharge": "Centro de Recarga",
        "Recharge": "Recargar",
        "self": "Canal",
        "uid": "Cambiar UID",
        "uuserName": "Apodo:",
        "Withdrawal": "Retirar"
    },
    "Weekly_Cp": {
        "7days": "7 días",
        "back": "Volver",
        "countdown": "Cuenta atrás",
        "day": "días",
        "diamonds": "https://image.pocketliveapp.com/image/activity/New%20Folder/diamonds.png",
        "event_rule": "<p>Notas</p><p>1. Todas las recompensas se acreditarán en tu cuenta dentro de los 3-5 días hábiles después de que termine el evento.</p><p>2. La tabla de clasificación calcula los diamantes gastados en enviar regalos del evento a otros usuarios. 1 diamante = 1 punto CP, y las 3 parejas de CP con más puntos CP recibirán recompensas del evento.</p><p>3. El evento termina todos los lunes a las 00:00 (UTC+8), y se liquidan los valores de la semana anterior.</p><p>4. Solo se contará el 10% de los diamantes gastados en regalos de la suerte.</p>",
        "gift": "Regalos del Evento",
        "hour": "Hora",
        "last_week": "La semana pasada",
        "last_week_rank": "Lista de la semana pasada",
        "minute": "Minuto",
        "pocketcoins": "https://image.pocketliveapp.com/image/activity/New%20Folder/coins.png",
        "reward": "Recompensas",
        "rule": "Reglas",
        "rule_reward": "Reglas y Recompensas",
        "seconds": "Segundos",
        "title": "Soulmate",
        "top1": "TOP1",
        "top1_pictures_1": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top1_pictures_1_name": "Marco de Avatar de la Estrella Semanal",
        "top1_pictures_2": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top1_pictures_2_name": "Marco de Avatar de Mejor Apoyo",
        "top1_pictures_3": "https://cos.koudailive.com/image/goods/2011_cloth_female.png?t=1678879041",
        "top1_pictures_34_name": "Traje de la Estrella Semanal",
        "top1_pictures_4": "https://cos.koudailive.com/image/goods/2010_suit_male.png?t=1678879038",
        "top2": "TOP2",
        "top2_pictures_1": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top2_pictures_2": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top3": "TOP3",
        "top3_pictures_1": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top3_pictures_2": "https://image2.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top46": "TOP 4-6",
        "top710": "TOP 7-10"
    },
    "Withdrawal": "Instrucciones de Retiro",
    "withdrawalInstructions": {
        "text1": "La función de retiro está disponible actualmente solo en países seleccionados.",
        "text2": "El tiempo que toma procesar los retiros puede variar según el canal.",
        "text3": "El monto real recibido puede ser ligeramente inferior al monto mostrado debido a las fluctuaciones del tipo de cambio y las tarifas.",
        "text4": "Solo puedes retirar una vez al día.",
        "text5": "Si tienes algún problema, por favor contáctanos."
    },
    "withdrawalLogin": {
        "accountId": "ID de cuenta Pix",
        "accountIdTips": "",
        "accountIdtsa": "El ID de cuenta Pix no puede estar vacío",
        "accountType": "Tipo de cuenta Pix",
        "code": "Código de verificación:",
        "Confirm": "Confirmar",
        "documentId": "Número de identificación personal",
        "documentIdTips": "",
        "documentIdtsa": "El tipo de ID no puede estar vacío",
        "documentType": "Tipo de identificación",
        "getAccount": "Obtener cuenta",
        "getUserId": "Por favor, ingresa el ID de usuario",
        "incorrectAccount": "Cuenta incorrecta",
        "login": "Iniciar sesión",
        "loginSuccessful": "Inicio de sesión exitoso",
        "name": "Nombre de usuario Pix",
        "nameTips": "",
        "nametsa": "La longitud debe estar entre 5 y 100 caracteres",
        "officialGroup": "Si tienes alguna pregunta, por favor contacta a nuestro soporte oficial",
        "pocket": "Saldo de Monedas",
        "Pocket": "Saldo insuficiente de Monedas",
        "Send": "Enviar",
        "text": "El código de verificación se enviará dentro de la aplicación",
        "title": "Retiro de ganancias",
        "title2": "Detalles del retiro",
        "user_id": "ID de la Cuenta:",
        "Whatsapp": "Cuenta de Whatsapp incorrecta",
        "WhatsappTips": "",
        "applicationTime": "Fecha de Solicitud",
        "amount": "Monto a Retirar",
        "success": "Éxito",
        "applicationSuccess": "Solicitud Enviada"
    },
    "top1AnchorRewards": "Recompensa de Host Top 1",
    "top2_3AnchorRewards": "Recompensas de Host Top 2-3",
    "top4_10AnchorRewards": "Recompensas de Host Top 4-10",
    "top1Icon7day": "Marco de Avatar *7 Días",
    "top1_2Icon7day": "Efecto de Entrada *7 Días",
    "top3Icon7day": "Marco de Avatar *7 Días",
    "top1VIPRewards": "Premio VIP al mejor 1",
    "top2_3VIPRewards": "Top 2-3 premios VIP",
    "top4_10VIPRewards": "Top 4-10 premios VIP",
    "relastionship": {
        "des": [
            "",
            "1. Después de enviar un regalo de relación, la otra persona puede elegir si desea establecer una relación contigo. Solo puede existir un tipo de relación entre dos personas.",
            "2. Dentro de 7 días naturales (UTC+3) después de establecer la relación, la intimidad no se reducirá. Después del período de protección, si la intimidad no aumenta 50 puntos en un día, disminuirá un 10% a medianoche (mínimo 1). Cuando la intimidad llegue a 0, la relación se romperá a medianoche. Si no aumenta 50 puntos en 10 días seguidos, la relación terminará automáticamente.",
            "3. Puedes terminar la relación 24 horas después de formarla. Después de terminarla, puedes volver a establecerla 24 horas más tarde.",
            "4. Cada persona tiene 3 espacios de relación por defecto. Puedes gastar diamantes para comprar más, cada espacio cuesta 99.999 diamantes, y puedes comprar hasta 10. También puedes aumentar tus espacios subiendo tu nivel VIP.",
            "Nivel VIP",
            "Total de espacios de relación ampliables"
        ]
    },
    "gift_album_des1": "Enviar los regalos anteriores puede ayudarlo/la a desbloquear el Álbum Semanal - \"Viaje Mundial\" y obtener recompensas.",
    "gift_album_des2": "Enviar los regalos anteriores puede ayudarlo/la a desbloquear el Álbum Permanente - \"Foco Amoroso\" y obtener recompensas.",
    "gift_album_des3": "Enviar los regalos anteriores puede ayudarlo/la a desbloquear el Álbum Permanente - \"Guarda SVIP\" y obtener recompensas.",
    "gift_album_des4": "Enviar los regalos anteriores puede ayudarlo/la a desbloquear el Álbum Permanente - \"Boda Soñada\" y obtener recompensas.",
    "gift_album_des5": "Ve a [Perfil] - [Muro de Regalos] - [Álbum] para ver los detalles",
    "gift_album_des8": "Enviar los regalos mencionados arriba puede ayudarle a activar el álbum permanente – 'Fiesta de Cumpleaños' y obtener recompensas.",
    "gift_album_des7": "Enviar los regalos anteriores puede ayudarlo/ayudarla a iluminar el Álbum Permanente - \"Estrella de la habitación\" y obtener recompensas.",
    "gift_harifata": "Burj Khalifa",
    "gift_sailing_hotel": "Burj Al Arab",
    "gift_mosque": "gran Mezquita",
    "gift_abatta": "Torre Abate",
    "gift_sphinx": "Esfinge",
    "svip_gift_1": "SVIP1",
    "svip_gift_2": "SVIP2",
    "svip_gift_3": "SVIP3",
    "svip_gift_4": "SVIP4",
    "svip_gift_5": "SVIP5",
    "svip_gift_6": "SVIP6",
    "gift_conf_lv1": "Corazón Latido",
    "gift_conf_lv2": "Enamoramiento",
    "gift_conf_lv3": "Amor infinito",
    "gift_conf_lv4": "Para siempre",
    "gift_habibi": "Amigo",
    "gift_bestie": "Amiga",
    "gift_couple": "Amor",
    "gift_confidant": "BFF",
    "weding_gift_kiss": "Beso",
    "weding_gift_ring": "Anillo",
    "weding_gift_proposal": "Propuesta de matrimonio",
    "weding_gift_castle": "Castillo",
    "weding_gift_wedding_dress": "Vestido de novia",
    "weding_gift_wedding": "Boda",
    "gift_album_des6": "Reglas",
    "guild_can_with": "Disponible",
    "guild_with_ing": "En proceso",
    "guild_self_withdraw": "Retiro propio",
    "guild_transfer_to_leader": "Transferir al líder de agencia",
    "guild_salary_to_reseller": "Transferir a revendedor",
    "guild_convert_to_diamond": "Convertir a diamantes",
    "guild_platform_settlement": "Liquidación de la plataforma",
    "guild_withdrawal_records": "Historial de retiros",
    "guild_current_withdrawable_pcoin": "Monedas disponibles",
    "guild_transfer_pcoin_amount": "Monto a transferir",
    "guild_all": "Todos",
    "guild_read_before_withdraw": "Lee antes de retirar:",
    "guild_withdraw_note_1": "Enviar",
    "guild_withdraw_note_2": "Fondos insuficientes para retirar",
    "guild_min_withdraw_amount": "¿Confirmar envío?",
    "guild_withdraw_note_4": "Cancelar",
    "guild_appeal_to_platform": "Confirmar",
    "guild_submit_application": "Método de retiro",
    "guild_withdraw_below_min": "Retiro del líder",
    "guild_confirm_submit_application": "Hora de solicitud",
    "guild_freeze_notice": "Tiempo de proceso",
    "guild_communicate_with_leader": "Motivo de rechazo",
    "guild_cancel": "Monto reembolsado",
    "guild_confirm": "Pendiente",
    "guild_withdrawal_method": "Completado",
    "guild_leader_withdraw": "Rechazado",
    "guild_status_timeout_rejected": "Rechazado automáticamente (tiempo agotado)",
    "guild_status_unknown": "Desconocido",
    "guild_status_platform_review": "En revisión (Plataforma)",
    "guild_status_guild_review": "En revisión (Agencia)",
    "guild_status_timeout_rejected_2": "Tiempo agotado (Devuelto)",
    "guild_status_platform_rejected": "Rechazado por plataforma",
    "guild_status_guild_leader_approval": "Pasa a Agencia en <span>{n}</span>h",
    "guild_apply_time": "Solo últimos 3 meses",
    "guild_process_time": "¿Dudas sobre retiros?",
    "guild_rejection_reason": "Contactar soporte",
    "guild_amount_refunded": "Revendedor verificado",
    "guild_status_pending": "Solo revendedores",
    "guild_status_completed": "Disponible",
    "guild_status_rejected": "Monto a transferir",
    "guild_show_last_3_months": "Llegada estimada",
    "guild_withdrawal_question": "Éxito",
    "guild_contact_customer_service": "Convertir a diamantes",
    "guild_certified_reseller": "Monedas disponibles para convertir",
    "guild_not_reseller_cannot_transfer": "Convertir",
    "guild_current_withdrawable": "Convertido",
    "guild_transfer_amount": "Moneda liquidada",
    "guild_estimated_arrival": "Solicitud enviada",
    "guild_read_before_operation": "1. Confirma con el revendedor los detalles del pago offline con anticipación",
    "guild_transfer_note_1": "2. Solo se permiten transferencias a revendedores",
    "guild_transfer_note_2": "Confirmar transferencia",
    "guild_confirm_transfer": "¿Confirmar envío?",
    "guild_confirm_submit_transfer": "Se descontarán {n} monedas",
    "guild_deduct_pcoin_receive_diamond": "Coordina los detalles del pago con el revendedor",
    "guild_communicate_with_reseller": "Transacción exitosa",
    "guild_operation_success": "Convertir a diamantes",
    "guild_exchange_diamond": "Monedas disponibles para convertir",
    "guild_current_exchangeable_pcoin": "Convertir",
    "guild_exchange": "Conversión exitosa",
    "guild_exchange_success": "Monedas por liquidar",
    "guild_settlement_pcoin_amount": "1. Confirma con el equipo de Operaciones el método de retiro con anticipación",
    "guild_settlement_note_1": "2. Los pagos se procesarán el próximo lunes",
    "guild_settlement_note_2": "3. Retiro mínimo: {n} monedas",
    "guild_settlement_min_amount": "Solicitud enviada",
    "guild_application_submitted": "Se descontarán {n} monedas",
    "guild_deduct_pcoin": "Coordina los detalles del pago con el equipo de Operaciones",
    "guild_user_not": "Usuario no encontrado",
    "guild_please_enter_amount": "Ingresa el monto",
    "guild_insufficient_balance": "Saldo insuficiente",
    "guild_please_enter_reseller_uid": "Ingresa el UID del RESELLER",
    "guild_please_search_reseller_first": "Busca al RESELLER primero",
    "guild_select_hand": "Selecciona una acción",
    "guild_ci_hand": "1. Esta acción enviará una solicitud al Líder del Gremio,",
    "guild_offline_transfer_funds": "y el pago será realizado offline por el líder",
    "guild_ci_hand_2": "2. Confirma con el líder el método de pago con antelación (tarjeta bancaria / USDT, etc.)",
    "guild_ci_hand_3": "3. El monto mínimo de retiro es {n} Coins",
    "guild_ci_hand_4": "4. Si el líder confirma el pago y no lo recibes, conserva los registros del chat y",
    "guild_ci_hand_5": "presenta una apelación a la plataforma",
    "guild_ci_hand_6": "El sistema congelará {n} Coins hasta que el líder lo procese",
    "guild_ci_hand_7": "Confirma el canal de retiro con el líder; el pago es offline",
    "guild_tips_1": "Coins disponibles por debajo del mínimo",
    "guild_contact_service": "Contacta a operaciones para coordinar el pago",
    "guild_reseller_tips": "Tus monedas ahora son diamantes del otro usuario. Habla con él/ella sobre el pago.",
    "gift_collection_detail_permanent_birthday": "Fiesta de Cumpleaños",
    "gift_collection_detail_permanent_roomstar": "Estrella de la habitación",
    "gift_holy_sword": "Espada Sagrada",
    "gift_volcano": "Volcán",
    "gift_emperor_come_world": "La Suerte Ha Llegado",
    "gift_castle_of_love": "Castillo del Amor",
    "gift_Immortal_god_war": "Dios Inmortal de la Guerra",
    "gift_king_of_gods": "Rey de Dioses",
    "birthday_gift_cybergift": "Regalo Cyber",
    "birthday_gift_wish": "Deseo de Lámpara",
    "birthday_gift_cake": "Pastel Dorado",
    "birthday_gift_lion": "Bendición León",
    "birthday_gift_biggift": "Regalo de Lujo",
    "guild_page_fee": "Tarifa de $2 por retiro",
    "guild_page_saudi": "Arabia Saudita",
    "guild_page_morocco": "Marruecos",
    "guild_page_bank": "Banco",
    "guild_page_name": "Nombre (en inglés)",
    "guild_page_name_english": "El nombre debe estar en inglés",
    "guild_page_bank_number": "Número de cuenta bancaria",
    "guild_page_enter": "Ingresa un número de cuenta válido",
    "guild_page_address": "Dirección (en inglés)",
    "guild_page_address_english": "La dirección debe estar en inglés",
    "guild_page_country": "País/Región",
    "guild_page_holder_name": "Nombre del titular de la cuenta",
    "guild_page_sa": "Ej.: SA8200000000XXXXXXXXXXXX",
    "guild_page_format": "Formato: Calle, Zona, Ciudad, Estado, País",
    "guild_page_minimum": "3. El monto mínimo de retiro es {n} Coins",
    "withdraw_input_amount": "Ingresa el monto",
    "withdraw_submit": "Retirar",
    "withdraw_quantity": "Monto de retiro",
    "withdraw_actual_received": "Monto neto recibido",
    "common_confirm": "Confirmar",
    "common_cancel": "Cancelar",
    "withdraw_error_min_amount": "No se alcanzó el mínimo de retiro",
    "withdraw_error_max_amount": "Supera el límite máximo de retiro",
    "withdraw_error_max_p_coin": "Supera las monedas disponibles para retirar",
    "guild_can_with_usd": "Retirable (≈USD {n})",
    "guild_pending_settlement": "Pendiente de liquidación",
    "guild_funds_operation": "Operación de fondos",
    "guild_withdrawable_amount_title": "Monto Retirable",
    "guild_withdrawable_amount_tip1": "1. Para garantizar la seguridad de los fondos y reducir los riesgos de seguridad, el sistema llevará a cabo una revisión de control de riesgos de cada ingreso de monedas. Durante el periodo de revisión, las monedas permanecerán en el estado «Pendiente de liquidación».",
    "guild_withdrawable_amount_tip2": "2. La revisión se completará en un plazo máximo de {s} horas. Si se aprueba, las monedas pasarán del estado «Pendiente de liquidación» al estado «Retirables»; si no se aprueba, el sistema lo gestionará de acuerdo con las normas.",
    "guild_withdrawable_amount_tip3": "3. En casos especiales, como fallos en la retirada o devoluciones, puedes retirar el dinero de inmediato.",
    "guild_got_it": "Entendido",
    "guild_pending_settlement_detail": "Detalles de liquidación pendientes",
    "guild_pending_settlement_tip": "Las ganancias de monedas de oro se convertirán en 'monto retirable' después de completar la liquidación segura y se espera que ingresen a tu saldo retirable en un máximo de {s} horas.",
    "guild_pending_settlement_amount": "Monto Pendiente de Liquidación",
    "guild_pending_settlement_last_30_days": "Solo se muestran registros de las últimas {n} horas",
    "guild_pending_settlement_list_tips": "Solo se muestran las ganancias pendientes de las últimas {n} horas. Los montos que han sido usados o deducidos no se mostrarán aquí. Puedes ir a",
    "guild_pending_settlement_list_tips_btn": "Página de registro de Coins",
    "guild_pending_settlement_list_tips_look": "Ver",
    "guild_pending_stamp_settled": "Liquidado",
    "guild_pending_stamp_used": "Usado",
    "guild_pending_stamp_deducted": "Deducido",
    "guild_record_guild_reward": "Recompensas de la agencia",
    "guild_record_gift": "Recibir regalo",
    "guild_order_id": "ID de Pedido",
    "guild_withdraw_record_total": "Total: {s} artículos",
    "guild_status_reseller_review": "reseller en revisión",
    "guild_status_security_review": "Revisión de seguridad",
    "guild_select_withdraw_amount": "Selecciona el monto de retiro",
    "guild_reference_fee": "Cuota de servicio",
    "guild_change_channel": "Cambiar",
    "guild_change_channel_title": "Cambiar canal",
    "guild_current_can_withdraw": "Disponible actualmente para retiro",
    "guild_confirm_bind": "Confirmar vinculación",
    "guild_bind_notice_title": "Tip",
    "guild_bind_tip_1": "El nombre debe coincidir con la autenticación de nombre real de la cuenta.",
    "guild_bind_tip_2": "La información incorrecta de la cuenta puede causar que el retiro falle y que los fondos no se reciban. Por favor, verifica cuidadosamente cada dato antes de enviar.",
    "guild_confirm_withdraw_info": "Confirmar la información de retiro",
    "guild_withdraw_amount_label": "Monto de retiro",
    "guild_estimated_arrival_time": "Tiempo estimado de llegada",
    "guild_confirm_info_tip": "Por favor, verifica cuidadosamente la información de retiro. Si hay algún error en la información, el pedido no se acreditará.",
    "guild_modify": "Editar",
    "guild_confirm_submit": "Confirmar envío",
    "guild_withdraw_success_tip": "Se espera que el monto se acredite en {s} días hábiles. Por favor, espera con paciencia. Puedes ir a la [Página de retiro] - esquina superior derecha [Registro de retiros] para verificar el progreso.",
    "guild_name": "Nombre",
    "guild_bank_account": "Cuenta bancaria",
    "guild_please_enter": "Por favor, ingresa",
    "guild_withdraw_submit_success": "Envío exitoso",
    "guild_withdraw_success_tip2": "Se espera que los fondos lleguen en {s} días hábiles. Por favor, ten paciencia. Puedes revisar el progreso en [Página de Retiro] - esquina superior derecha en [Historial de Retiros].",
    "guild_platform_settlement_success_tip": "Los pagos se procesarán todos juntos el próximo lunes. Por favor, ten paciencia. Puedes consultar el progreso yendo a la [Página de Retiro] y seleccionando [Registro de Retiros] en la esquina superior derecha.",
    "guild_transfer_to_reseller": "Transferir al distribuidor",
    "guild_transfer_to_reseller_label": "Transferir a revendedor",
    "guild_reseller_confirm_desc": "Por favor, confirma con el Revendedor los detalles del pago. Al hacer clic en 'Confirmar', se te descontará",
    "guild_reseller_confirm_tip_1": "1. Por favor, comunícate con el revendedor por adelantado sobre los detalles del pago fuera de línea.",
    "guild_reseller_confirm_tip_2": "2. Si la otra parte rechaza, tus monedas se devolverán automáticamente;",
    "guild_reseller_confirm_tip_3": "3. El monto mínimo de retiro es de {n} monedas.",
    "guild_leader_settle_subtitle": "El líder de la agencia hará la liquidación contigo fuera de la app",
    "guild_leader_confirm_desc": "Por favor, asegúrate de haber hablado sobre los detalles del pago con el líder de la agencia. Al hacer clic en 'Confirmar', se descontarán monedas.",
    "guild_leader_confirm_tip_1": "1. Esta operación enviará una solicitud al líder de la agencia, quien te realizará el pago fuera de línea;",
    "guild_leader_confirm_tip_2": "2. Por favor, confirma previamente el método de pago (tarjeta bancaria/USDT, etc.) con el líder de la agencia; si el líder de la agencia rechaza, tus monedas serán devueltas automáticamente;",
    "guild_leader_confirm_tip_3": "3. La cantidad mínima de retiro es {n} monedas;",
    "guild_leader_confirm_tip_4": "4. Si el líder de la agencia confirma que el pago fue realizado pero no has recibido el dinero, guarda el registro del chat y presenta una apelación en la plataforma.",
    "guild_leader_confirm_tip_4_prefix": "5. Si el líder de la agencia confirma que el pago se realizó pero no has recibido el dinero, guarda el registro del chat y haz una reclamación en la plataforma.",
    "guild_leader_platform_appeal": "Apelación a la plataforma",
    "pixNamePlaceholder": "Ingresa el nombre de usuario de pix",
    "pixIdType": "Tipo de ID",
    "transfer": {
        "bindSuccess": "Vinculación exitosa",
        "error": "La operación falló. Por favor, inténtalo de nuevo más tarde."
    },
    "pixSelectIdTypePlaceholder": "Selecciona tipo de ID",
    "pixIdPlaceholder": "Ingresa tu {s}",
    "pixSelectAccountTypePlaceholder": "Selecciona el tipo de cuenta pix",
    "pixAccountPlaceholder": "Ingresa tu {s}",
    "whatsAppIdPlaceholder": "Ingresa tu ID de WhatsApp",
    "pixCpfLengthError": "El CPF debe tener 11 dígitos",
    "pixCnpjLengthError": "El CNPJ debe tener 14 dígitos",
    "pixCpfNotMatchError": "Las dos entradas de CPF no coinciden",
    "pixCnpjNotMatchError": "Los dos CNPJ ingresados no coinciden",
    "pixFormatError": "Error de formato",
    "notFilled": "{s} no completado",
    "formatErrorCheck": "Error de formato, por favor verifica.",
    "certi_tips": "Sugerencia",
    "certi_tips1": "Para proteger la seguridad de tu cuenta y reducir el riesgo de ataques fraudulentos, debes completar la verificación antes de continuar. Ve a 'Mi' > 'Centro de Verificación' dentro de la aplicación para completar la verificación antes de seguir.",
    "certi_tips2": "Ir a verificar",
    "certi_tips3": "La versión actual es demasiado antigua. Por favor, actualiza y vuelve a intentarlo.",
    "certi_tips4": "Para proteger la seguridad de tu cuenta y reducir el riesgo de ataques ilegales, debes completar la verificación para continuar.",
    "ff": "¡Despegue de Cohete! ¡Enfréntate a los Multiplicadores Altos!",
    "dd": "Despega Ahora",
    "guild_country": "País/Región",
    "guild_bank_name": "Banco",
    "guild_iban": "IBAN",
    "guild_whatsapp": "WhatsApp",
    "guild_document_type": "Tipo de ID",
    "guild_document_id": "Número de ID",
    "guild_account_type": "Tipo de cuenta",
    "guild_address": "Dirección",
    "guild_settlement_weekly_process": "Se procesa de forma uniforme todos los lunes",
    "withdrawal_channel": "Canal de Retiro",
    "guild_whatsapp_contact_tip": "Por favor, deja tu información de contacto. Te contactaremos por WhatsApp",
    "guild_bind": "Vincular",
    "guild_settlement_input_amount": "Ingresa la cantidad a retirar",
    "gift_sphinx6": "Pirámide",
    "gift_sphinx7": "Torre Monas",
    "guild_no_more_data": "No hay más contenido",
    "guild_bind_channel_toast": "Por favor, vincula la información del canal primero"
}
